//@flow
import type Decimal from 'decimal.js'

export const totalPremium = (regularPremium: Decimal, regularTopUp: Decimal, lumpSum: Decimal): Decimal =>
  regularPremium.plus(regularTopUp).plus(lumpSum)
